import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a7c11c04&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wwwroot\\dealer-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7c11c04')) {
      api.createRecord('a7c11c04', component.options)
    } else {
      api.reload('a7c11c04', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a7c11c04&", function () {
      api.rerender('a7c11c04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/header-aside/components/header-notify/index.vue"
export default component.exports